import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, requiredRole }) => {
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");

    const loginType = requiredRole === "Employee"
        ? "employee"
        : requiredRole === "Contractor"
            ? "contractor"
            : requiredRole === "SuperAdmin"
                ? "superadmin"
                : "company";

    if (!token) {
        return <Navigate to={`/login/${loginType}`} replace />;
    }

    if (requiredRole && role !== requiredRole) {
        return <Navigate to={`/login/${loginType}`} replace />;
    }

    return children;
};

export default PrivateRoute;
